var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { API } from './api';
var DEFAULT_VALUES = {
    'banner.envWarning.hide': false,
    'banner.publishingDashboardHeader.hide': false,
    'detection.workspace.defaultBoxColor': '#FFFFFF',
    'detection.workspace.showLabels': true,
    'detection.workspace.requireSaveConfirmation': true,
    'detection.workspace.predictBoundingBoxClass': true,
    'detection.workspace.predictionsEnabled': false,
    'detection.workspace.showPixelDimensions': true,
    'detection.workspace.grid.color': '#eea83b',
    'detection.workspace.grid.visible': false,
    'detection.workspace.grid.rows': 10,
    'detection.workspace.grid.columns': 10,
    'segmentation.workspace.showLabels': true,
    'segmentation.workspace.showAnnotations': true,
    'segmentation.workspace.noClassColor': '#FFFFFF',
    'segmentation.workspace.requireSaveConfirmation': true,
    'scenerecognition.workspace.grid.color': '#eea83b',
    'scenerecognition.workspace.grid.visible': false,
    'scenerecognition.workspace.grid.rows': 10,
    'scenerecognition.workspace.grid.columns': 10,
    'anomalyrecognition.workspace.grid.color': '#eea83b',
    'anomalyrecognition.workspace.grid.visible': false,
    'anomalyrecognition.workspace.grid.rows': 10,
    'anomalyrecognition.workspace.grid.columns': 10,
    'evaluateBrain.imageDetails.showROI': true,
    // The explainability setting values here should match the values in DEFAULT_EXPLAINABILITY_OVERLAY_SETTINGS.
    'evaluateBrain.imageDetails.showExplainabilityOverlay': true,
    'evaluateBrain.imageDetails.explainabilityOpacity': 70,
    'navSidebar.isExpanded': true,
    'evaluateBrain.classPerformance.sortingMethodsByDataset': {
    // This property will be populated over time with entries in this format:
    // datasetIdentifier: <SortingMethods.METHOD>
    },
    'evaluateBrain.staticBrain.hasViewedStaticBrainTab': {
    // This property will be populated over time with entries in this format:
    // datasetIdentifier: <boolean>
    },
    'evaluateBrain.hifiBrain.hasViewedHiFiBrainTab': {
    // This property will be populated over time with entries in this format:
    // datasetIdentifier: <boolean>
    },
    'deploy.upgradeBanner.hide': false,
    'library.sortOrder': {
    // This property will be populated over time with entries in this format:
    // datasetIdentifier: '{"sort": "...", "order": "[asc|desc]"}' // this is a stringified JSON object
    },
    'library.pagniator.limit': {
    // This property will be populated over time with entries in this format:
    // datasetIdentifier: <number>
    }
};
export var SettingLifetime;
(function (SettingLifetime) {
    SettingLifetime["Session"] = "Session";
    SettingLifetime["Account"] = "Account";
})(SettingLifetime || (SettingLifetime = {}));
var SettingsProvider = /** @class */ (function (_super) {
    __extends(SettingsProvider, _super);
    function SettingsProvider(api) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.settings = {};
        return _this;
    }
    SettingsProvider.prototype.load = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensureLoaded(function () { return _this.fetchSettings(); }, force)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SettingsProvider.prototype.fetchSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rawSettings, sessionSettings, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get('users/settings')];
                    case 1:
                        rawSettings = _a.sent();
                        sessionSettings = this.fetchLocalStorageSettings();
                        return [2 /*return*/, Object.assign(this.settings, rawSettings.message.settings, sessionSettings)];
                    case 2:
                        err_1 = _a.sent();
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SettingsProvider.prototype.fetchLocalStorageSettings = function () {
        var currentSettings = JSON.parse(window.sessionStorage.getItem('settings') || '{}');
        return currentSettings;
    };
    SettingsProvider.prototype.get = function (settingKey) {
        if (this.settings.hasOwnProperty(settingKey)) {
            return this.settings[settingKey];
        }
        else if (DEFAULT_VALUES.hasOwnProperty(settingKey)) {
            return DEFAULT_VALUES[settingKey];
        }
        return null;
    };
    SettingsProvider.prototype.set = function (settingKey, settingValue, lifetime) {
        if (lifetime === void 0) { lifetime = SettingLifetime.Account; }
        return __awaiter(this, void 0, void 0, function () {
            var allSettings, _a, currentSettings, message, err_2, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 5, , 6]);
                        allSettings = {};
                        _a = lifetime;
                        switch (_a) {
                            case SettingLifetime.Session: return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 2];
                    case 1:
                        currentSettings = this.fetchLocalStorageSettings();
                        Object.assign(allSettings, (_b = {}, _b[settingKey] = settingValue, _b));
                        window.sessionStorage.setItem('settings', JSON.stringify(Object.assign(currentSettings, (_c = {}, _c[settingKey] = settingValue, _c))));
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.api.put('users/settings', (_d = {}, _d[settingKey] = settingValue, _d))];
                    case 3:
                        message = (_e.sent()).message;
                        Object.assign(allSettings, message.settings);
                        return [3 /*break*/, 4];
                    case 4:
                        Object.assign(this.settings, allSettings);
                        return [3 /*break*/, 6];
                    case 5:
                        err_2 = _e.sent();
                        throw err_2;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Persist a setting value that is a JSON map object
     * This is a convenience method that updates the saved map objects
     */
    SettingsProvider.prototype.mapSet = function (settingKey, mapKey, settingValue, lifetime) {
        if (lifetime === void 0) { lifetime = SettingLifetime.Account; }
        return __awaiter(this, void 0, void 0, function () {
            var mapObject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mapObject = this.get(settingKey) || {};
                        mapObject[mapKey] = settingValue;
                        return [4 /*yield*/, this.set(settingKey, mapObject, lifetime)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get a setting value that is in a JSON map object using a specific key
     * This is a convenience method around the existing get method
     */
    SettingsProvider.prototype.mapGet = function (settingKey, mapKey) {
        var mapObject = this.get(settingKey);
        if (mapObject) {
            return mapObject[mapKey];
        }
        else {
            return undefined;
        }
    };
    /**
     * Set multiple user settings at once
     *
     * @param {Object} settingsObject Settings to save, passed as an object `settingsObject`.
     *  For example, to save a new value ('Value A') to the key settingKeyA,
     *  AND a value ('Value B') to the key settingKeyB, the `settingsObject` param would be `{settingKeyA: "Value A", settingKeyB: "Value B"}`
     * @memberof SettingsProvider
     */
    SettingsProvider.prototype.setAll = function (settingsObject, lifetime) {
        if (lifetime === void 0) { lifetime = SettingLifetime.Account; }
        return __awaiter(this, void 0, void 0, function () {
            var allSettings, _a, currentSettings, message, err_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        allSettings = {};
                        _a = lifetime;
                        switch (_a) {
                            case SettingLifetime.Session: return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 2];
                    case 1:
                        currentSettings = this.fetchLocalStorageSettings();
                        Object.assign(allSettings, settingsObject);
                        window.sessionStorage.setItem('settings', JSON.stringify(Object.assign(currentSettings, settingsObject)));
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.api.put('users/settings', settingsObject)];
                    case 3:
                        message = (_b.sent()).message;
                        Object.assign(allSettings, message.settings);
                        return [3 /*break*/, 4];
                    case 4:
                        Object.assign(this.settings, allSettings);
                        return [3 /*break*/, 6];
                    case 5:
                        err_3 = _b.sent();
                        throw err_3;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    SettingsProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API])
    ], SettingsProvider);
    return SettingsProvider;
}(BaseProvider));
export { SettingsProvider };
//# sourceMappingURL=settings.js.map


// WEBPACK FOOTER //
// ./src/providers/settings.ts.pre-build-optimizer.js